export const profilePageHeaderStyles = {
	typeLabel: {
		color: 'text.secondary',
		justifyContent: 'center',
		paddingTop: 0.5,
		marginBottom: 0.5,
		fontSize: '0.75rem'
	}
};
